import React from 'react'

const InsideSearchIcon1 = () => {
    return (
        <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="0.455566" width="16" height="16" rx="2.54444" fill="white" />
            <g clipPath="url(#clip0_11_43)">
                <rect width="8.90555" height="8.90555" transform="translate(4.00281 3.54724)" fill="white" />
                <path d="M7.34265 5.77362V10.2264" stroke="#767676" strokeWidth="0.636111" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M9.56921 5.77362V10.2264" stroke="#767676" strokeWidth="0.636111" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M7.34236 5.77366C7.34236 5.15886 6.84396 4.66046 6.22916 4.66046C5.61436 4.66046 5.11597 5.15886 5.11597 5.77366C5.11597 6.38846 5.61436 6.88685 6.22916 6.88685H10.6819C11.2967 6.88685 11.7951 6.38846 11.7951 5.77366C11.7951 5.15886 11.2967 4.66046 10.6819 4.66046C10.0671 4.66046 9.56874 5.15886 9.56874 5.77366" stroke="#767676" strokeWidth="0.636111" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M7.34236 10.2264C7.34236 10.8412 6.84396 11.3396 6.22916 11.3396C5.61436 11.3396 5.11597 10.8412 5.11597 10.2264C5.11597 9.61161 5.61436 9.11322 6.22916 9.11322H10.6819C11.2967 9.11322 11.7951 9.61161 11.7951 10.2264C11.7951 10.8412 11.2967 11.3396 10.6819 11.3396C10.0671 11.3396 9.56874 10.8412 9.56874 10.2264" stroke="#767676" strokeWidth="0.636111" strokeLinecap="round" strokeLinejoin="round" />
            </g>
            <defs>
                <clipPath id="clip0_11_43">
                    <rect width="8.90555" height="8.90555" fill="white" transform="translate(4.00281 3.54724)" />
                </clipPath>
            </defs>
        </svg>


    )
}

export default InsideSearchIcon1
